<template>
  <Bar :data="barChartData" :options="barChartOptions" />
</template>

<script>
import { Bar } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
import { useTheme } from "vuetify";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: "BarChart",
  components: { Bar },
  setup() {
    const theme = useTheme();
    return { theme };
  },
  props: {
    chartData: Array,
    chartLabels: Array,
    onClick: Function,
  },
  computed: {
    barChartData() {
      const c = this.theme.current.value.colors;
      return {
        datasets: [
          {
            data: this.chartData,
            backgroundColor: this.chartLabels.map((_, i) => c[`chart-${(i % 5) + 1}`]),
            label: "Invoices",
          },
        ],
        labels: this.chartLabels,
      };
    },
    barChartOptions() {
      return {
        onClick: (event, elements) => {
          if (this.onClick && elements.length > 0) this.onClick(elements[0].index);
        },
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1,
            },
          },
        },
      };
    },
  },
};
</script>
